import HttpServices from "./BaseAPI";

export async function GetApiRoutes() {
    return await HttpServices.get(`/`);
}

export async function GetAccountManagerByEmail(email) {
    let request = `Settings/AccountManager/GetByEmail?email=${email}`;
    return await HttpServices.get(request, { headers: { ['skipError']: true } });
}

export async function GetCountryCodes() {
    let data = await HttpServices.get(`/Settings/Country/CountryCodeList?PageNumber=1&PageSize=500`);
    return data;
}

export async function GetRolesList() {
    let data = await HttpServices.get(`/Security/Role/ListForLookup?PageNumber=1&PageSize=500`);
    return data;
}

export async function GetSubscriptionLevelsList() {
    let data = await HttpServices.get(`Contracts/SubscriptionLevel/List?PageNumber=1&PageSize=100`);
    return data;
}

export async function GetSubscriptionTeamSizeList() {
    let data = await HttpServices.get(`Contracts/SubscriptionTeamSize/List?PageNumber=1&PageSize=100`);
    return data;
}

export async function GetSubscriptionCountryPriceList() {
    let data = await HttpServices.get(`Contracts/SubscriptionCountryPrice/ListAll?PageNumber=1&PageSize=100`);
    return data;
}